import { render, staticRenderFns } from "./BackendList.vue?vue&type=template&id=2c7ef2f3&scoped=true&"
import script from "./BackendList.vue?vue&type=script&lang=js&"
export * from "./BackendList.vue?vue&type=script&lang=js&"
import style0 from "./BackendList.vue?vue&type=style&index=0&id=2c7ef2f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ef2f3",
  null
  
)

export default component.exports